import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { connect } from "react-redux";
import CalendarIcon from "@untitled-ui/icons-react/build/esm/Calendar";
import { Input, Row, Card, Form, DatePicker, Col, Divider, Spin } from "antd";
import { BOM } from "../../../../../services/definedMethod";
import cnt from "../../../../../services/definedConstant";
import CustomButton from "../../../../../components/custom/CustomButton";
import { showCheckerApprovalModal } from "../../../../../components/CheckerModal";
import { apiConfig, labelConfig, staticConfig } from "../wallet.config";
import MainLayout from "../../../../../components/layouts/enhancement/MainLayout";
import TopContent from "../../../../../components/layouts/enhancement/TopContent";

const { TextArea } = Input;
const ActivateWalletAcc = (props) => {
  const { userData, isSubWallet = false } = props;
  const { session } = userData;
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const { state } = useLocation();
  console.log(state);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    console.log(state);
  }, []);

  // const disabledAfterCurrentDate = (current) => {
  //   return current && current.valueOf() > Date.now();
  // };

  function onCancel() {
    navigate(isSubWallet ? "/detail-sub-wallet" : "/detail-wallet-account", {
      state: state,
    });
  }

  const onSubmit = (formValues) => {
    const url = `${apiConfig.WalletAccount}/${state.id}/activate`;
    formValues.activatedOnDate = BOM.DateTime(
      formValues.activatedOnDate,
      "only-date"
    );
    const body = {
      ...formValues,
      dateFormat: "dd MMMM yyyy",
      locale: "en",
      method: "POST",
      session,
    };
    setIsLoading(true);
    BOM.FetchReqAction(
      body,
      url,
      (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
          setIsLoading(false);
        } else {
          BOM.AlertMsg(cnt.SUCCESS, "Wallet Account was updated");
          navigate(
            isSubWallet ? "/detail-sub-wallet" : "/detail-wallet-account",
            {
              state: { ...state, statusValue: "activated" },
            }
          );
          //STOP LOAD
          setIsLoading(false);
        }
      },
      {
        navigate,
        showCheckerModal: showCheckerApprovalModal,
        onCheckerApproval: (res) => {
          navigate(
            isSubWallet ? "/detail-sub-wallet" : "/detail-wallet-account",
            { state: { ...state } }
          );
          setIsLoading(false);
        },
      }
    );
  };

  return (
    <MainLayout pageItems={staticConfig.activateWalletAccountBreadcrumbItems}>
      {/* PART 1  IMPORT TOP CONTENT*/}
      <TopContent
        pageTitle={isSubWallet ? "Sub Wallet Account" : "Wallet Account"}
        createPageTitle={
          isSubWallet
            ? "Activate Sub Wallet Account"
            : "Activate Wallet Account"
        }
      />

      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
            marginTop: 20,
          }}
        >
          <Form form={form} layout="vertical" onFinish={onSubmit}>
            <Row>
              <Divider orientation="left">{`Account No: ${state?.contractObj?.savingsAccountData?.accountNo}`}</Divider>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={"Activated on"}
                  name={"activatedOnDate"}
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.date),
                    },
                  ]}
                >
                  <DatePicker
                    suffixIcon={<CalendarIcon color="#667085" width={20} />}
                    disabledDate={BOM.DisabledAfterCurrentDate}
                    style={{ width: "100%", height: "44px" }}
                  />
                </Form.Item>
              </Col>
              {/* <Col span={12} style={{ padding: "0px 8px" }}>
                <Form.Item label={"Note"} name={"note"}>
                  <TextArea
                    placeholder={BOM.handlePlaceholderMsg("Note")}
                    autoSize={{
                      minRows: 2,
                      maxRows: 6,
                    }}
                  />
                </Form.Item>
              </Col> */}
            </Row>

            <Row>
              <Divider />
              <CustomButton
                content="Submit"
                style={{
                  width: "10%",
                  marginLeft: "auto",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                  backgroundColor: "#BA24D5",
                  color: "white",
                  border: "1px solid #BA24D5",
                  fontSize: "16px",
                  fontWeight: "600",
                }}
                htmlType="submit"
                backgroundColor="#BA24D5"
                colorText="white"
                hoverBackground="#AD4EA7"
              />

              <CustomButton
                content="Cancel"
                style={{
                  width: "10%",
                  marginLeft: "1%",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                  backgroundColor: "#BA24D5",
                  color: "white",
                  border: "1px solid #BA24D5",
                  fontSize: "16px",
                  fontWeight: "600",
                }}
                backgroundColor="#fff"
                colorText="black"
                hoverBackground="#F5F5F5"
                onClick={onCancel}
              />
            </Row>
          </Form>
        </Card>
      </Spin>
    </MainLayout>
  );
};
export default ActivateWalletAcc;
